import { httpClient } from "ultis/axios";

const getListAgent = (params) => {
  return httpClient.get("/call-center/agent", {
    params,
  });
};

export const AgentApi = {
  getListAgent,
};
